// Throttling enforces a maximum number of times a function can be called over time
// tslint:disable-next-line no-any
function throttle(f: (...args: any[]) => void, ms: number) {
	let isThrottled = false;
	let savedArgs: any; // tslint:disable-line no-any
	let savedThis: any; // tslint:disable-line no-any

	// tslint:disable-next-line no-any
	function wrapper(this: any) {
		if (isThrottled) {
			savedArgs = arguments;
			savedThis = this;
			return;
		}

		f.apply(this, arguments);

		isThrottled = true;

		setTimeout(function() {
			isThrottled = false;
			if (savedArgs) {
				wrapper.apply(savedThis, savedArgs);
				savedArgs = savedThis = null;
			}
		}, ms);
	}

	return wrapper;
}

// filterWithMax() will filter an array "array" with the method "condition" and stops after finding a maximum number "maxSize" of elements
// source: https://stackoverflow.com/a/56169001/6246007
function* filterWithMax<ItemType>(array: ItemType[], condition: (item: ItemType) => boolean, maxSize: number) {
	if (!maxSize || maxSize > array.length) {
		maxSize = array.length;
	}
	let count = 0;
	let i = 0;
	while (count < maxSize && i < array.length) {
		if (condition(array[i])) {
			yield array[i];
			count++;
		}
		i++;
	}
}

export { throttle, filterWithMax };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/optimization.ts